// extracted by mini-css-extract-plugin
export default {"container":"EC","promoapplied":"FC","tobeapplied":"GC","hr":"HC","teal":"IC","promoappliedcontainer":"JC","error":"KC","input":"LC","errorInput":"MC","promo_x":"NC","promo_info":"OC","promoxcontainer":"PC"};
    if(module.hot) {
      // 1715632477965
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  